import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { DropdownMenu, optionProps } from '@paypalcorp/pp-react';
import styles from './GeoLocOverride.module.less';

const GeoLocOverride = ({ content }: { content: optionProps[] }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedGeoLocaleOverride =
    content.find((opt) => opt.value === searchParams.get('geoLocOverride'))?.value || 'US';

  const handleChange = (e: React.ChangeEvent<HTMLButtonElement>) => {
    searchParams.set('geoLocOverride', e.target.value);
    setSearchParams(searchParams);
    window.location.reload();
  };

  return (
    <div className={styles.container}>
      <DropdownMenu
        label="Geo Location Override"
        value={selectedGeoLocaleOverride}
        options={content}
        onChange={handleChange}
      />
    </div>
  );
};

export default GeoLocOverride;
